var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50ZM24.5282 26.8125L10 19.1167V32.4861L10.0068 32.7417C10.0709 33.8928 10.565 34.9753 11.3879 35.7671C12.2107 36.559 13.2998 37.0001 14.4318 37H35.5682L35.8191 36.9931C36.9493 36.9278 38.0121 36.4245 38.7895 35.5864C39.567 34.7484 40.0001 33.6391 40 32.4861V19.1181L25.4718 26.8125C25.3261 26.8897 25.1643 26.93 25 26.93C24.8357 26.93 24.6739 26.8897 24.5282 26.8125ZM35.5682 12H14.4318L14.1809 12.0069C13.0507 12.0722 11.9879 12.5755 11.2105 13.4136C10.433 14.2516 9.99993 15.3609 10 16.5139V16.7694L25 24.7139L40 16.7694V16.5139L39.9932 16.2583C39.9291 15.1072 39.435 14.0247 38.6121 13.2329C37.7893 12.441 36.7002 11.9999 35.5682 12Z",
    fill: "#FAF4ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.fa1ed6d20fb8555ccc49d02090e6bd54.svg";
export { ForwardRef as ReactComponent };